export enum TavernGames {
  flipCoin = 'flipCoin',
  pusher = 'pusher'
}

export interface StatsTableOptions {
  isHideSecondaryPlayerInfo?: boolean;
  isHideCoin?: boolean;
  isWinStatusHidden?: boolean;

  rewardsBlock?: {
    label: string;
  };
}
